const fbq = (...args) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') window.fbq(...args);
};

export const trackPageView = () => fbq('track', 'PageView');
export const trackLead = (params = {}) => fbq('track', 'Lead', params);
export const trackEnrollment = (params = {}) => fbq('trackCustom', 'Enrollment', params);
